module.exports = __webpack_public_path__ + "img/pflege.5a9d75ee.svg";